import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify';

import './plugins/vuetify';
import store from './store/index';
import App from './App.vue';
import router from './router';

import 'vuetify/dist/vuetify.min.css';

import VueClip from 'vue-clip';

Vue.use(VueClip);

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(Vuetify);

new Vue({
    router,
    render: (h) => h(App),
    store,
}).$mount('#app');

